import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({activities,navigate}) => {


const getColorClasses = (color) => {
const colors = {
primary: 'bg-primary/10 text-primary',
success: 'bg-success/10 text-success',
warning: 'bg-warning/10 text-warning',
accent: 'bg-accent/10 text-accent'
};
return colors?.[color] || colors?.primary;
};

const empty = !activities || activities.length === 0;

return (
<div className="bg-card border border-border rounded-lg p-6">
<div className="flex items-center justify-between mb-6">
<h3 className="text-base sm:text-lg font-semibold text-text-primary">Recent Activity</h3>
<button 
onClick={()=>navigate('/notifications')}
className="text-sm text-primary hover:text-primary/80 spring-transition">
View All
</button>
</div>

{empty ? (
<div className="flex flex-col items-center justify-center py-10 text-center">
<Icon name="Inbox" size={40} className="text-text-secondary mb-3" />
<p className="text-sm text-text-secondary">No recent activity</p>
<p className="text-xs text-text-secondary mt-1">
Updates will appear here as you apply and get matches.
</p>
</div>
) : (
<div className="space-y-4">
{activities.map((activity) => (
<div key={activity.id} className="flex items-start space-x-3">
<div className={`p-2 rounded-lg ${getColorClasses(activity.color)}`}>
<Icon name={activity.icon} size={16} />
</div>
<div className="flex-1 min-w-0">
<p className="text-sm font-medium text-text-primary">{activity.title}</p>
<p className="text-sm text-text-secondary mt-1">{activity.description}</p>
<p className="text-xs text-text-secondary mt-1">{activity.timestamp}</p>
</div>
</div>
))}
</div>
)}
</div>
);
};

export default ActivityFeed;